<template>
  <div class="page">
    <PageToolbar :title="`Trades`" :hasBack="!isInMainView">
      <MBPButton v-if="isInMainView" label="Add a new trade" class="action" @click="goToNewTrade()"></MBPButton>
      <MBPButton v-if="!isInMainView " class="action" @click="saveTrade()" label="Save trade"/>
    </PageToolbar>

    <router-view ref="view"/>
  </div>
</template>

<script>
import PageToolbar from "../components/ui/PageToolbar";
import MBPButton from "../components/ui/controls/MBPButton";

import {events} from '../services/events';

export default {
  name: "TradesPVT",
  components: {MBPButton, PageToolbar},
  data () {
    return {
      viewLoaded: false
    }
  },
  computed: {
    isInMainView () {
      return this.$route.name === 'TradesTablePVT';
    }
  },
  methods: {
    saveTrade() {

      events.emit('saveTrade');
    },
    goToNewTrade () {
      this.$router.push('/tradespvt/trade');
      this.$router.go(1);
    }
  }
}
</script>

<style scoped lang="scss">

</style>
